import { Component, Input, OnInit, OnChanges } from "@angular/core";

import { Iceutility } from "../../../../icemedx-lib/src/services/iceutility";
import { MatDialog } from "@angular/material";
import { patient } from "../../../../icemedx-lib/src/models/domain/patient";
import { userTypes } from "../../../../icemedx-lib/src/login/login.config";
import { IceTypes } from "../../../../icemedx-lib/src/models/icetypes";
import { appointment } from "../../../../icemedx-lib/src/models/schedule/appointment";

import { AppService } from "../../../../../src/app/app.service";
import { DomainService } from "../../../../icemedx-lib/src/services/domain/domain.service";
import { PatientService } from "../../../../icemedx-lib/src/services/patient/patient.service";
import { ScheduleService } from "../../../../icemedx-lib/src/services/schedule/schedule.service";

@Component({
  selector: 'app-listofappointments',
  templateUrl: './listofappointments.component.html',
  styleUrls: ['./listofappointments.component.scss']
})
export class ListOfAppointmentsComponent implements OnInit, OnChanges {
  @Input() patient: string = null;
  @Input() appointmentKeys: string[] = [];
  appointments: appointment[] = [];

  private hasAccess: boolean = true;
  private currentPatient: string;
  private selectedAppointment: appointment;

  constructor(private appSvc: AppService, private domainSvc: DomainService, private ptSvc: PatientService, private dialog: MatDialog) { }

  ngOnInit() {
    let feaAccess = this.appSvc.getPermission(userTypes.USER_FEATURES.ufExternalDocuments).default_access;
    if (feaAccess == userTypes.USER_FEATURE_ACCESS.ufaNone) {
      this.hasAccess = false;

      setTimeout(_ => {
        this.domainSvc.logMessage(IceTypes.LOGTYPE.ltError, "You do not have access to view this data.");
      });
    } else {
      this.getAppointments();
      let ptAct = this.appSvc.getCurrentPatient();

      if (Iceutility.isStringUndefinedNullOrEmpty(ptAct)) {
        ptAct = this.patient;
      }

      if (!Iceutility.isStringUndefinedNullOrEmpty(ptAct)) {
        this.setCurrentPatient(ptAct);
      }
    }
  }

  ngOnChanges(changeObj) {
    if (Iceutility.isdefined(changeObj.appointmentKeys)) {
      if (changeObj.appointmentKeys.currentValue !== changeObj.appointmentKeys.previousValue && this.hasAccess) {
        this.getAppointments();
      }
    }

    if (Iceutility.isdefined(changeObj.patient) && Iceutility.isdefined(changeObj.patient.previousValue)) {
      if (changeObj.patient.currentValue !== changeObj.patient.previousValue && this.hasAccess) {
        this.setCurrentPatient(changeObj.patient.currentValue);
      }
    }
  }

  private getAppointments() {
    if (Iceutility.isStringUndefinedNullOrEmpty(this.patient) && Iceutility.isStringUndefinedNullOrEmpty(this.appSvc.getCurrentPatient()))
      return;

    if (this.appointmentKeys.length > 0) {
      this.ptSvc.getAllAppointments(!Iceutility.isStringUndefinedNullOrEmpty(this.patient) ? this.patient : this.appSvc.getCurrentPatient(), "", IceTypes.ACCOUNT_TYPE.actNone, "", "", "", "").subscribe(
        data => {
          this.appointments = this.processAppointmentData(data);
        },
        error => {
          this.domainSvc.logMessage(IceTypes.LOGTYPE.ltError, "An error occurred while fetching appointments");
        });
    }
  }

  private processAppointmentData(data) {
    let appointments: appointment[] = [];

    for (let iAppt = 0; iAppt < data.length; iAppt++) {
      let appt = data[iAppt];
      for (let key of this.appointmentKeys) {
        if (key === appt.appointment_key && !Iceutility.isdefined(appointments.find(a => a.appointment_key === appt.appointment_key))) {
          appt._time_slot_start_display = Iceutility.getDateTextEx(appt.time_slot_start);
          appt._time_slot_end_display = Iceutility.getDateTextEx(appt.time_slot_end);
          appt._appointment_status_text = ScheduleService.getApptStat(Iceutility.toLong(appt.appointment_status));
          appt._appointment_type_text = ScheduleService.getAppointmentType(Iceutility.toLong(appt.appointment_type));
          this.getProviderNames(appt, appt.provider_keywords.split(","));
          appointments.push(appt);
        }
      }
    }

    return appointments;
  }

  private getProviderNames(appointment, providers) {
    this.domainSvc.getProviderNames(providers)
      .subscribe(_ => {
        let mappedNames = providers.map(p => {
          if (!Iceutility.isStringUndefinedNullOrEmpty(p.trim())) {
            return DomainService.mappedProviders[p.trim().toLowerCase()];
          }
          return "";
        }).join(", ");

        mappedNames = mappedNames.trim();
        if (mappedNames.substr(mappedNames.length - 1) === ",") {
          mappedNames = mappedNames.slice(0, mappedNames.length - 1);
        }
        appointment._provider_names = mappedNames;
      }, error => console.log(error));
  }

  private setCurrentPatient(ptAct) {
    this.domainSvc.getPatient(ptAct, this.appSvc.getCurrentAccount()).subscribe(
      data => {
        if (data != null && data.length > 0) this.currentPatient = this.appSvc.getPatientName(<patient>data[0]);
      });
  }

  private showAppointmentDetails(templateRef, selectedAppointment) {
    this.selectedAppointment = selectedAppointment;

    this.dialog.open(templateRef, {
      width: '500px',
      panelClass: 'ice-dialog'
    });
  }
}
